import React from "react"
import { BaseViewProp } from "../../types/type"
import Style from "./Card.module.css"

type CardProps = BaseViewProp & {
  className?: string
}
export default function Card({ children, className }: CardProps): React.ReactElement {
  return <div className={`${Style.card} ${className}`}>{children}</div>
}
